import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn-standard className combiner. Use this in every component instead
 * of template-literal concatenation so Tailwind merge correctly resolves
 * conflicting utilities (e.g. `p-4 p-6` → `p-6`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format a date as "Jun 17, 2026". */
export function formatDate(iso?: string | Date | null): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}

/**
 * Renders backend "unlimited" values (encoded as int.MaxValue from the
 * .NET capacity service) as "∞" so cards don't show 2147483647.
 */
export function formatQuota(n: number): string {
  if (n >= 1_000_000_000) return "∞";
  return n.toLocaleString();
}

/** "12.4 GB" / "350 MB" — picks the unit that reads cleanest. */
export function formatStorage(gb: number): string {
  if (gb >= 1_000_000) return "∞";
  if (gb >= 1) return `${gb.toFixed(gb < 10 ? 2 : 1)} GB`;
  return `${Math.round(gb * 1024)} MB`;
}
